import { useAuth } from "../auth/AuthContext";
import { PlaygroundBody } from "./PlaygroundBody";

const QUICK_STORAGE_KEY = "ccs-quick-script-files";

const DEFAULT_MAIN_PY = `# Quick script. Write Python, then tap Run.
print("Hello!")
`;

/** Ephemeral scratch IDE: code + console, with a Simple/Advanced toggle and "Save as playground". */
export default function QuickScriptPage() {
  const { profile } = useAuth();
  const isTeacher = profile?.role === "teacher";
  const playgroundsHome = isTeacher ? "/teacher/playground" : "/playground";

  return (
    <PlaygroundBody
      eyebrow="Quick script"
      title="Quick script"
      backTo={playgroundsHome}
      backLabel="Playgrounds"
      initialFiles={[{ path: "main.py", content: DEFAULT_MAIN_PY }]}
      filesStorageKey={QUICK_STORAGE_KEY}
      quickScript={{ defaultMode: "simple" }}
    />
  );
}
